<template>
  <div id="view-one">
    <div class="content">
      <img class="img" :src="data.banner">
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewOne",
  props: ["data"],
}
</script>

<style scoped lang="scss">
@import "../style.scss";

#view-one {
  width: 100%;
  .content {
    width: 100%;
    max-width: 500px;
    margin: 0 auto -5px auto;
    .img {
      width: 100%;
    }
  }

  @media only screen and (min-device-width: 768px) {
    .content {
      box-shadow: $deep-shadow;
    }
  }
}
</style>
